import { useEffect } from 'react'
import { useExpedition } from '../store/useExpedition.js'

export function OpeningSequence({ reducedMotion }) {
  const phase=useExpedition(state=>state.introPhase)
  const setCamera=useExpedition(state=>state.setCameraDirective)
  const finish=useExpedition(state=>state.finishIntro)
  useEffect(()=>{
    if(phase!=='departing') return
    const durations=reducedMotion?[250,800,1450]:[900,3000,6200]
    const timers=[
      setTimeout(()=>setCamera({type:'opening-route',id:'pearl-to-chautauqua',position:[7,5,-24],target:[-2,-1,-1],fov:34,speed:.72}),durations[0]),
      setTimeout(()=>setCamera({type:'opening-mountain',id:'flatirons-reveal',position:[8,10.5,-38],target:[-6,2.2,5],fov:38,speed:.62}),durations[1]),
      setTimeout(finish,durations[2]),
    ]
    return()=>timers.forEach(clearTimeout)
  },[finish,phase,reducedMotion,setCamera])
  if(phase!=='departing') return null
  return <div className="opening-sequence"><div><span>1941 PEARL STREET · BOULDER</span><p>The client is the entrepreneur.</p><p>The weather is the market.</p><p>The route is the company.</p></div><button onClick={finish}>Take control ↗</button></div>
}
